export const QUEBEC = 'QC'
